import React, { memo, useState } from 'react';
import i18n from '../../../utilities/i18n';
import { useFormikContext } from 'formik';
import TextInputWithError from '../../ui/forms/TextInputWithError';
import TextAreaWithError from '../../../components/ui/forms/TextAreaWithError';
import {
  Highlight,
  IconBannersWarning,
  HStack,
  LinkText,
  Text,
  VStack,
} from '@adc/parallax-component-library';
import { StudyCreateFormValues } from '../StudyCreate';
import { ChangeOrganizationModal } from '../../modal/ChangeOrganizationModal';
import PreventSubmitWrapper from '../../ui/forms/PreventSubmitWrapper';
import { useQuery } from '@tanstack/react-query';
import { organizationsQueryOptions } from '../../../queryOptions';
import { useAppSelector } from '../../../reducers/hooks';

const TabInfo = () => {
  const { errors } = useFormikContext<StudyCreateFormValues>();

  const organizationKey = useAppSelector(
    (state) => state.organizations.currentOrgKey,
  );

  const organizations = useQuery(organizationsQueryOptions());

  const [changeOrganizationModalOpen, setChangeOrganizationModalOpen] =
    useState(false);

  return (
    <VStack
      height={'100%'}
      width="100%"
      gap="$2"
      backgroundColor="$neutral.0"
      padding="$2"
      justifyContent="flex-start"
    >
      {errors?.errorMessage ? (
        <VStack marginBottom={'$4'}>
          <Highlight
            variant="danger"
            iconStart={
              <IconBannersWarning
                color="$neutral.0"
                accentColor="$support.danger.default"
              />
            }
            title={i18n.t('Common.errorGenericTitle')}
            body={errors.errorMessage}
          />
        </VStack>
      ) : null}

      {organizations.data ? (
        <HStack alignItems="flex-end" gap="$2">
          <VStack>
            <Text type="$bodySmall.default" color="$text.60" textAlign="left">
              {i18n.t('Page_StudyCreate.tab_sites_organization_label')}
            </Text>
            <Text type="$bodyBase.default" textAlign="left">
              {
                organizations.data?.find((org) => org.key === organizationKey)
                  ?.name
              }
            </Text>
          </VStack>
          {organizations.data.length > 1 ? (
            <PreventSubmitWrapper>
              <LinkText
                onPress={() => {
                  setChangeOrganizationModalOpen(true);
                }}
                href=""
                type="$bodyBase.default"
              >
                {i18n.t('Common.change')}
              </LinkText>
            </PreventSubmitWrapper>
          ) : null}

          <ChangeOrganizationModal
            open={changeOrganizationModalOpen}
            onClose={() => setChangeOrganizationModalOpen(false)}
          />
        </HStack>
      ) : null}

      <TextInputWithError
        label={i18n.t('Entity.name')}
        name="name"
        testID="name"
      />
      <TextAreaWithError
        label={i18n.t('Entity.description')}
        name="description"
        testID="description"
      />
      <TextInputWithError
        label={i18n.t('Entity.type')}
        name="type"
        testID="type"
      />
      <TextInputWithError
        label={i18n.t('Entity.region')}
        name="region"
        testID="region"
      />
    </VStack>
  );
};

export default memo(TabInfo);
